import React, { useEffect, useState } from 'react';
import Editor from '@monaco-editor/react';

const JsonEditor = ({ value, onChange, height = 300, readOnly = false }) => {
  const initial = typeof value === 'string' ? value : JSON.stringify(value || {}, null, 2);
  const [text, setText] = useState(initial);
  const [error, setError] = useState('');

  useEffect(() => {
    const next = typeof value === 'string' ? value : JSON.stringify(value || {}, null, 2);
    setText(next);
  }, [value]);

  const handleChange = (val) => {
    const v = val || '';
    setText(v);
    try {
      const parsed = v ? JSON.parse(v) : {};
      setError('');
      if (onChange) onChange(true, parsed);
    } catch (e) {
      const msg = e && e.message ? e.message : 'Invalid JSON';
      setError(msg);
      if (onChange) onChange(false, null);
    }
  };

  return (
    <div>
      <Editor
        height={height}
        defaultLanguage="json"
        value={text}
        onChange={handleChange}
        options={{
          readOnly,
          minimap: { enabled: false },
          formatOnPaste: true,
          formatOnType: true,
          scrollBeyondLastLine: false,
        }}
      />
      {error && (
        <div className="alert alert-danger mt-2" role="alert">
          Invalid JSON: {error}
        </div>
      )}
    </div>
  );
};

export default JsonEditor;
